// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"grid-module--wrapper--RI2IH","customMedia":{},"customProperties":{},"customSelectors":{}};